/* SIZESOFTX
=========================================================================================
* Descripción: Menú de acciones del catálogo de Corridas
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1        | 25/04/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2        | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from 'react';
import { useDoubleClickPrevention } from '../../../hooks/useDoubleClickPrevention';
import { Tooltip, IconButton } from '@mui/material';
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from "@mui/icons-material/Refresh";
import UndoIcon from '@mui/icons-material/Undo';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

import { useCorridas } from "../../../context/Catalogos/CorridasContext";

export default function MnuCorridasActions({ onOpenModalEliminarTodas }) {
    const {
        handleClickRegresarMainDashboard,
        handleClickNuevaCorrida,
        handleClickGuardarCorrida,
        handleClickEliminarCorrida,
        handleClickRefrescarDatos,
        handleClickDeshacer,
        handleClickEliminarTodasCorridas,
        statusEditCorridas,
        corridaSeleccionada,
        statusOpenModalEliminarCorrida,
        setStatusOpenModalEliminarCorrida,
    } = useCorridas();

    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const hayCorridaSeleccionada = corridaSeleccionada && 
                                  corridaSeleccionada.descripcion && 
                                  corridaSeleccionada.descripcion.trim().length > 0;

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Nuevo'}>
                <IconButton onClick={() => executeWithProtection(handleClickNuevaCorrida)} disabled={isProcessing}>
                    <AddIcon className="icon" /><p className="icon">Nuevo</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Guardar'}>
                <IconButton disabled={isProcessing || statusEditCorridas} onClick={() => executeWithProtection(handleClickGuardarCorrida)}>
                    <SaveIcon className="icon" /><p className="icon">Guardar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Eliminar'}>
                <IconButton 
                    disabled={isProcessing || statusEditCorridas || !hayCorridaSeleccionada} 
                    onClick={() => executeWithProtection(() => setStatusOpenModalEliminarCorrida(true))}>
                    <DeleteIcon className="icon" /><p className="icon">Eliminar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Refrescar'}>
                <IconButton onClick={handleClickRefrescarDatos}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip>
            <Tooltip title={'Deshacer'}>
                <IconButton disabled={isProcessing || statusEditCorridas} onClick={() => executeWithProtection(handleClickDeshacer)}>
                    <UndoIcon className="icon" /><p className="icon">Deshacer</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Eliminar Todas'}>
                <IconButton onClick={() => onOpenModalEliminarTodas && executeWithProtection(onOpenModalEliminarTodas)} disabled={isProcessing || !onOpenModalEliminarTodas}>
                    <DeleteSweepIcon className="icon" color="error" /><p className="icon" style={{color: 'red'}}>Eliminar Todo</p>
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}
